"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuctionRegistrationStatusDto = instanceOfAuctionRegistrationStatusDto;
exports.AuctionRegistrationStatusDtoFromJSON = AuctionRegistrationStatusDtoFromJSON;
exports.AuctionRegistrationStatusDtoFromJSONTyped = AuctionRegistrationStatusDtoFromJSONTyped;
exports.AuctionRegistrationStatusDtoToJSON = AuctionRegistrationStatusDtoToJSON;
exports.AuctionRegistrationStatusDtoToJSONTyped = AuctionRegistrationStatusDtoToJSONTyped;
/**
 * Check if a given object implements the AuctionRegistrationStatusDto interface.
 */
function instanceOfAuctionRegistrationStatusDto(value) {
    if (!('isRegistered' in value) || value['isRegistered'] === undefined)
        return false;
    return true;
}
function AuctionRegistrationStatusDtoFromJSON(json) {
    return AuctionRegistrationStatusDtoFromJSONTyped(json, false);
}
function AuctionRegistrationStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isRegistered': json['isRegistered'],
    };
}
function AuctionRegistrationStatusDtoToJSON(json) {
    return AuctionRegistrationStatusDtoToJSONTyped(json, false);
}
function AuctionRegistrationStatusDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'isRegistered': value['isRegistered'],
    };
}
